import { Parsing } from "./parsing";

class SkProp extends Parsing {
  private exp: any;

  constructor(
    private elem: HTMLElement,
    private prop: string,
    private value: string,
    private module: any
  ) {
    super();
    this.exp = Parsing.expression(value);
    this.update();
  }

  private update(): void {
    const value = this.exp.call(this.module);
    this.elem[this.prop] = value;
  }
}

export { SkProp };
